<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1hsF9z/tc-custom/9781507189344.jpg?1692614730308" alt="This image is the cover for the book Uma Vida com Lobisomens"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uma Vida com Lobisomens
      </h1>
      <p class="bookDescription body article font2">
        <p>Um novo predador. Um salvador inesperado. Uma jornada dentro do desconhecido.<br/> Taya experimenta sua primeira transformação como um lobisomem, e é mais assustadora do que ela tinha imaginado. Colocada de volta na Reserva Blackfoot Werewolf, ela tem de lidar com olhos acusadores e um alfa bastante agressivo.<br/> Esta é a parte 5 de 6.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K. Matthew, Maria Birkenhead
      </h2>
      
      <p class="authorDescription body article">K. Matthew escreve histórias de romances fumegantes em uma variedade de gêneros. De bilionários fogosos a transformadores com apetites vorazes por seus amores curvilíneos, há alguma coisa para todos.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?682e4ac3